"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
require("core-js/modules/es.object.define-property");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.signInWithCustomToken = signInWithCustomToken;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

/**
 * signInWithCustomToken
 * Use a custom token provided from the server to sign the user in
 * @param {String} token - firebase custom auth JWT token
 */
function signInWithCustomToken(_x) {
  return _signInWithCustomToken.apply(this, arguments);
}
function _signInWithCustomToken() {
  _signInWithCustomToken = (0, _asyncToGenerator2["default"])(/*#__PURE__*/
  _regenerator["default"].mark(function _callee(token) {
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (this.firebase) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return", true);
          case 2:
            return _context.abrupt("return", this.firebase.auth().signInWithCustomToken(token));
          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  return _signInWithCustomToken.apply(this, arguments);
}